module.exports = __webpack_public_path__ + "static/media/dragonflycancertrust.7cc3ef30.png";